module.exports = __webpack_public_path__ + "img/template-placeholder.f71062bb.png";